import { Component, Input } from "@angular/core";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Task } from "@src/app/models/task";
import { CustomertasklistService } from "./service/customertasklist.service";
import { Projectmember } from "@src/app/models/projectmember";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-customertasklist",
  templateUrl: "./customertasklist.component.html",
  styleUrls: ["./customertasklist.component.css"],
})
export class CustomertasklistComponent {
  showSpinner: boolean;
  taskList: Task[];
  @Input() responsible: string;
  @Input() mylist: boolean;
  customerUsers: Projectmember[];
  customerId: string;
  constructor(
    private datastore: DatastoreService,
    private ctlsrv: CustomertasklistService
  ) {}

  ngOnInit(): void {
    this.showSpinner = true;
    this.taskList = [];
    this.customerId = JSON.parse(SessionHelper.getCustomer()).customerId.split(
      "_"
    )[0];

    //todo get customer users and filter out tasks that are not assigned to a customer user
    this.ctlsrv.getCustomerMembers(this.customerId).pipe(untilDestroyed(this)).subscribe((members) => {
      //console.log(members);
      this.customerUsers = members;
      this.getTasks();
    });
  }

  //Get tasks from datastore
  async getTasks() {
    this.datastore.getCustomerProjects(new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(
      (projects) => {
       //console.log("Get projects customer portal", projects);
    this.datastore.loadProjectDependentData(projects);

    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tasks) => {
     //console.log('Get tasks customer portal',tasks);
      //Filter out tasks that are not visible to customer
      this.taskList = tasks.filter(
        (t) =>
          t.taskvisibility != "vendor_only" &&
          t.taskstate != "Done" &&
          ((t.responsible == this.responsible && this.mylist) ||
            (t.responsible != this.responsible &&
              !this.mylist &&
              this.customerUsers.find(
                (u) => u.userId.split("_")[0] == t.responsible
              )))
      );

      // tasks.forEach(t => {
      //   if( t.taskvisibility != 'vendor_only' && t.taskstate != 'Done' && ((t.responsible == this.responsible && this.mylist) || (t.responsible != this.responsible && !this.mylist))){
      //   var index = this.taskList.findIndex(tl => tl.taskId == t.taskId);
      //   if(index != -1){

      //     if(this.taskList[index].validfrom != t.validfrom){
      //       this.taskList[index] = t;
      //     }

      //   }else{
      //    // add to list if responsible is me or part of customer users
      //    if(t.customer == this.customerId && (this.mylist || this.customerUsers.find(u => u.userId.split('_')[0] == t.responsible))){
      //       this.taskList.push(t);
      //    }

      //   }
      // }else{
      //   var index = this.taskList.findIndex(tl => tl.taskId == t.taskId);
      //   if(index != -1){
      //     this.taskList.splice(index,1);
      //   }
      // }
      // });

      //if responsible is set, filter out tasks that are not assigned to the responsible
      // if(this.responsible && this.mylist){
      //   this.taskList = this.taskList.filter(t => t.responsible == this.responsible);
      // }else if(this.responsible && !this.mylist){
      //   this.taskList = this.taskList.filter(t => t.responsible != this.responsible );
      //   //filter out tasks that are not assigned to a customer user
      //   this.taskList = this.taskList.filter(t => this.customerUsers.find(u => u.personId == t.responsible));

      // }

      // //Filter out done tasks
      // this.taskList = this.taskList.filter(t => t.taskstate != 'Done');
      //Sort by duedate
      this.taskList.sort((a, b) =>
        a.duedate > b.duedate ? 1 : b.duedate > a.duedate ? -1 : 0
      );

      this.showSpinner = false;
    });
  });
  }
}
